export const GET_BARCODE_MANUFACTURERS = 'GET_BARCODE_MANUFACTURERS';
export const GET_BARCODE_MANUFACTURERS_SUCCESS = 'GET_BARCODE_MANUFACTURERS_SUCCESS';
export const GET_BARCODE_MANUFACTURERS_ERROR = 'GET_BARCODE_MANUFACTURERS_ERROR';
export const RESET_BARCODE_MANUFACTURERS = 'RESET_BARCODE_MANUFACTURERS';
